import { Injectable, Input } from '@angular/core';
import { TableConfig, TableData } from '../interfaces/table.interface';

@Injectable({
  providedIn: 'root',
})
export class TableDataService {
  getSampleTableData(): TableData[] {
    return [
      {
        idProspecto: '0000000001',
        prospecto: 'Gregorio Antunes Castrouridiales',
        registro: 'Registrado',
        mensajes: '1',
        tiempo_sin_respuesta: '25d 10h 14m 38s',
        tiempo_sin_respuesta_cliente: '17d 26h 41m 38s',
      },
      {
        idProspecto: '0000000001',
        prospecto: 'Isabel del Valle Begijar',
        registro: 'Registrado',
        mensajes: '1',
        tiempo_sin_respuesta: '1d 12h 23m 12s',
        tiempo_sin_respuesta_cliente: '9d 23h 41m 48s',
      },
      {
        idProspecto: '0000000001',
        prospecto: 'Prospecto sin Registrar - 656 75 65 76',
        registro: 'Sin Registrar',
        mensajes: '2',
        tiempo_sin_respuesta: '10d 09h 27m 32s',
        tiempo_sin_respuesta_cliente: '3d 23h 41m 48s',
      },
      {
        idProspecto: '0000000001',
        prospecto: 'Carlos Aurelio Gutiérrez Martínez',
        registro: 'Registrado',
        mensajes: '2',
        tiempo_sin_respuesta: '7d 12h 23m 12s',
        tiempo_sin_respuesta_cliente: '7d 19h 21m 28s',
      },
      {
        idProspecto: '0000000001',
        prospecto: 'Karen Hernández',
        registro: 'Registrado',
        mensajes: '1',
        tiempo_sin_respuesta: '5d 12h 23m 12s',
        tiempo_sin_respuesta_cliente: '19d 11h 31m 18s',
      },
      {
        idProspecto: '0000000001',
        prospecto: 'Geraldo Santiago Camacho Jimenez',
        registro: 'Registrado',
        mensajes: '0',
        tiempo_sin_respuesta: '1d 12h 29m 32s',
        tiempo_sin_respuesta_cliente: '5d 8h 32m 59s',
      },
      {
        idProspecto: '0000000001',
        prospecto: 'Rebecca Contreras',
        registro: 'Registrado',
        mensajes: '0',
        tiempo_sin_respuesta: '0d 17h 14m 32s',
        tiempo_sin_respuesta_cliente: '7d 20h 38m 21s',
      },
    ];
  }
  getSampleTableConfig(): TableConfig {
    return {
      columns: undefined,
      data: this.getSampleTableData(),
      pagination: {
        enabled: true,
        pageSize: 10,
        pageSizeOptions: [5, 10, 25, 50, 100],
      },
      filtering: {
        enabled: true,
        placeholder: 'Buscar ...',
      },
      sorting: {
        enabled: true,
      },
    };
  }

  // Configuración alternativa para la tabla original de etapas
  getEtapasTableConfig(): TableConfig {
    return {
      columns: [
        {
          key: 'etapa',
          title: 'ETAPA',
          type: 'text',
          width: '200px',
          sortable: true,
          filterable: true,
        },
        {
          key: 'descripcion',
          title: 'DESCRIPCIÓN',
          type: 'text',
          width: '250px',
          sortable: true,
          filterable: true,
        },
        {
          key: 'fecha_ejecucion',
          title: 'FECHA EJECUCIÓN',
          type: 'date',
          width: '140px',
          sortable: true,
        },
        {
          key: 'registros_actuales',
          title: 'REGISTROS ACTUALES',
          type: 'text',
          width: '120px',
          sortable: true,
        },
        {
          key: 'total_registros',
          title: 'TOTAL REGISTROS',
          type: 'number',
          width: '120px',
          sortable: true,
        },
        {
          key: 'registros_enviados',
          title: 'REGISTROS ENVIADOS',
          type: 'number',
          width: '120px',
          sortable: true,
        },
        {
          key: 'resumen_envios',
          title: 'RESUMEN ENVÍOS',
          type: 'text',
          width: '150px',
          sortable: true,
        },
        {
          key: 'status',
          title: 'STATUS',
          type: 'badge',
          width: '120px',
          sortable: true,
          badgeConfig: {
            colorMap: {
              Activo: 'badge-active',
              Deshabilitado: 'badge-inactive',
              Pendiente: 'badge-pending',
              Completado: 'badge-success',
            },
          },
        },
        {
          key: 'filtro',
          title: 'FILTRO',
          type: 'text',
          width: '200px',
          sortable: true,
        },
        {
          key: 'fecha_registro',
          title: 'FECHA DE REGISTRO',
          type: 'date',
          width: '140px',
          sortable: true,
        },
        {
          key: 'acciones',
          title: 'ACCIONES',
          type: 'button',
          width: '120px',
          buttonConfig: {
            text: 'Editar',
            action: 'edit',
            class: 'btn-primary',
          },
        },
      ],
      data: [
        {
          etapa: 'Filtro prueba Mayo23',
          descripcion:
            'Pruebas de prospectos para mayo 2023, todos los martes.',
          fecha_ejecucion: '2023-02-13',
          registros_actuales: 57912,
          total_registros: 0,
          registros_enviados: 0,
          resumen_envios: 'BDC-18 SMS-755',
          status: 'Activo',
          filtro: 'Tipo de cliente = "Post-venta"',
          fecha_registro: '2023-02-13',
        },
        {
          etapa: 'Nombres de María',
          descripcion: 'Pruebas María',
          fecha_ejecucion: '2023-02-10',
          registros_actuales: 311,
          total_registros: 292,
          registros_enviados: 292,
          resumen_envios: 'BDC-292',
          status: 'Deshabilitado',
          filtro: 'Nombre = "María"',
          fecha_registro: '2023-02-10',
        },
        {
          etapa: 'Chrysler 1° Semana Enero 23',
          descripcion: 'Todas las ventas de Chrysler de Enero de 2023',
          fecha_ejecucion: '2023-02-10',
          registros_actuales: 14,
          total_registros: 14,
          registros_enviados: 14,
          resumen_envios: 'BDC-14',
          status: 'Activo',
          filtro: 'Tipo de cliente = "Post-venta"',
          fecha_registro: '2023-02-08',
        },
        {
          etapa: 'Acura 1° trimestre 23',
          descripcion: 'Pruebas de prospectos para El Acura, todos los martes.',
          fecha_ejecucion: '2023-01-14',
          registros_actuales: 6,
          total_registros: 6,
          registros_enviados: 6,
          resumen_envios: 'MAIL-6',
          status: 'Deshabilitado',
          filtro: 'Tipo de cliente = "Post-venta"',
          fecha_registro: '2023-02-06',
        },
        {
          etapa: 'Prospectos por avisar',
          descripcion: 'Prospectos por avisar el 28 de Mayo',
          fecha_ejecucion: '2023-01-13',
          registros_actuales: 6,
          total_registros: 0,
          registros_enviados: 0,
          resumen_envios: '',
          status: 'Activo',
          filtro:
            'Fecha del próximo servicio = "Entre 2022-12-15 & 2022-12-30"',
          fecha_registro: '2023-02-01',
        },
        {
          etapa: 'Mensual Hyundai',
          descripcion: 'Envíos mensuales para la base de datos de Hyundai',
          fecha_ejecucion: '2023-01-10',
          registros_actuales: 111,
          total_registros: 98,
          registros_enviados: 98,
          resumen_envios: 'BDC-90 SMS-8',
          status: 'Activo',
          filtro: 'Tipo de cliente = "Post-venta"',
          fecha_registro: '2023-01-13',
        },
      ],
      pagination: {
        enabled: true,
        pageSize: 10,
        pageSizeOptions: [5, 10, 25, 50, 100],
      },
      filtering: {
        enabled: true,
        placeholder: 'Buscar en todos los campos...',
      },
      sorting: {
        enabled: true,
      },
    };
  }
}
